import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22161 32047"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:459.808}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970278511408">
        <path
          d="M230 9132v12959l10850-8836 10851 8836V9132L11080 297z"
          className="fill stroke1"
          style={{
            strokeWidth: 459.808,
          }}
        />
        <path
          d="M230 27334v4230l10850-8836 10851 8836v-4230l-10851-8835z"
          className="fill stroke1"
          style={{
            strokeWidth: 459.808,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
